import { render, staticRenderFns } from "./ScreenSchedule.vue?vue&type=template&id=96369c0c&scoped=true&lang=pug"
import script from "./ScreenSchedule.vue?vue&type=script&lang=ts"
export * from "./ScreenSchedule.vue?vue&type=script&lang=ts"
import style0 from "./ScreenSchedule.vue?vue&type=style&index=0&id=96369c0c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96369c0c",
  null
  
)

export default component.exports